import React from "react";
import {
  GridColumn,
  Header,
  Segment,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "semantic-ui-react";
import moment from "moment";
import { SWBLabel } from "../UtilComponents";

const SwapTasksTable = ({ swapTasks }) => {
  return (
    <GridColumn>
      <Segment>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Header style={{ color: "#444" }}>{swapTasks.length} Tasks</Header>
        </div>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="left-header">
                Task ID
              </Table.HeaderCell>

              <Table.HeaderCell className="inner-header">
                Action
              </Table.HeaderCell>
              <Table.HeaderCell className="inner-header">
                Battery ID
              </Table.HeaderCell>
              <Table.HeaderCell className="inner-header">
                Module
              </Table.HeaderCell>

              <Table.HeaderCell className="inner-header">Slot</Table.HeaderCell>

              <Table.HeaderCell className="inner-header">
                Timestamp
              </Table.HeaderCell>
              <Table.HeaderCell className="inner-header">
                Updated at
              </Table.HeaderCell>

              <Table.HeaderCell className="right-header">
                State
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <TableBody>
            {swapTasks.map(
              ({
                module_number,
                created_at,
                action,
                slot_number,
                task_id,
                updated_at,
                battery_id,
                status,
              }) => (
                <TableRow>
                  <TableCell>{task_id}</TableCell>
                  <TableCell>{action}</TableCell>
                  <TableCell>{battery_id}</TableCell>

                  <TableCell>{module_number}</TableCell>

                  <TableCell>{slot_number}</TableCell>

                  <TableCell>
                    {moment(created_at).format("DD-MM-YYYY HH:mm:ss")}
                  </TableCell>
                  <TableCell>
                    {moment(updated_at).format("DD-MM-YYYY HH:mm:ss")}
                  </TableCell>
                  <TableCell>
                    <SWBLabel
                      content={status}
                      activated={status === "completed"}
                    />
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
        {!swapTasks.length && (
          <div style={{ alignSelf: "center", color: "#444", width: "100%" }}>
            no data available
          </div>
        )}
      </Segment>
    </GridColumn>
  );
};

export default SwapTasksTable;
